module.exports = __webpack_public_path__ + "static/media/how-it-works.3684638c.png";